<template>
  <v-container fluid>
    <v-row no-gutters>
      <v-col cols="12">
        <v-row justify="center">
          <v-col align="center" cols="6" md="2">
            <router-link :to="`/reported-posts`">
              <v-icon color="#066a8c">mdi-post-outline</v-icon>
              <div class="mnuBtn">Reported Posts</div>
            </router-link>
          </v-col>

          <v-col align="center" cols="6" md="2" class="btn_bg">
            <router-link :to="`/reported-users`">
              <v-icon color="#066a8c">mdi-account-group</v-icon>
              <div class="mnuBtn">Reported Users</div>
            </router-link>
          </v-col>

          <v-col align="center" cols="6" md="2">
            <router-link :to="`/reported-medias`">
              <v-icon color="#066a8c">mdi-folder-multiple-image</v-icon>
              <div class="mnuBtn">Reported Medias</div>
            </router-link>
          </v-col>
        </v-row>

        <v-row>
          <div class="user-wrapper">
            <div
              class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-50"
            >
              <div class="md-card md-theme-default fullwidth">
                <div class="md-card-content">
                  <v-row>
                    <v-col md="3"
                      ><span class="header_title"> Reported Users </span></v-col
                    >
                    <v-spacer></v-spacer>
                    <v-col md="2" class="mr-3">
                      <div style="width: 120px; float: right">
                        <v-select
                          outlined
                          v-model="perPage"
                          label="Per Page"
                          :items="[10, 15, 25, 50]"
                          @change="searchDatas"
                          :menu-props="{ bottom: true, offsetY: true }"
                        ></v-select>
                      </div>
                    </v-col>
                  </v-row>
                  <div
                    class="md-content md-table md-theme-default table_borders"
                    table-header-color="orange"
                    value
                  >
                    <div
                      class="md-content md-table-content md-scrollbar md-theme-default"
                    >
                      <table>
                        <thead class="md-card-header">
                          <tr>
                            <th class="md-table-head">
                              <div
                                class="md-table-head-container md-ripple md-disabled"
                              >
                                <div class="md-table-head-label">Name</div>
                                <div class="search_column">
                                  <v-autocomplete
                                    solo
                                    filled
                                    label="Name"
                                    v-model="searchParams.name"
                                    item-value="name"
                                    item-text="name"
                                    :items="names"
                                    :loading="isLoading"
                                    :search-input.sync="name"
                                    @change="getFilterData"
                                  ></v-autocomplete>
                                </div>
                              </div>
                            </th>

                            <th class="md-table-head">
                              <div
                                class="md-table-head-container md-ripple md-disabled"
                              >
                                <div class="md-table-head-label">email</div>
                                <div class="search_column">
                                  <v-autocomplete
                                    solo
                                    filled
                                    label="Email"
                                    v-model="searchParams.email"
                                    item-value="email"
                                    item-text="email"
                                    :items="emails"
                                    :loading="isLoading"
                                    :search-input.sync="email"
                                    @change="getFilterData"
                                  ></v-autocomplete>
                                </div>
                              </div>
                            </th>
                            <th class="md-table-head">
                              <div
                                class="md-table-head-container md-ripple md-disabled"
                              >
                                <div class="md-table-head-label">
                                  Profession
                                </div>
                                <div class="search_column">
                                  <v-autocomplete
                                    solo
                                    filled
                                    label="Profession"
                                    v-model="searchParams.profession"
                                    item-value="profession"
                                    item-text="profession"
                                    :items="professions"
                                    :loading="isLoading"
                                    :search-input.sync="profession"
                                    @change="getFilterData"
                                  ></v-autocomplete>
                                </div>
                              </div>
                            </th>
                            <th
                              class="md-table-head"
                              style="position: relative"
                            >
                              <div
                                class="md-table-head-container md-ripple md-disabled"
                              >
                                <div class="md-table-head-label">
                                  Company Name
                                </div>
                                <div class="search_column">
                                  <v-autocomplete
                                    solo
                                    filled
                                    label="Company Name"
                                    v-model="searchParams.company_name"
                                    item-value="company_name"
                                    item-text="company_name"
                                    :items="company_names"
                                    :loading="isLoading"
                                    :search-input.sync="company_name"
                                    @change="getFilterData"
                                  ></v-autocomplete>
                                </div>
                              </div>
                            </th>

                            <th class="md-table-head">
                              <div
                                class="md-table-head-container md-ripple md-disabled"
                              >
                                <div class="md-table-head-label">Gender</div>
                                <div class="search_column">
                                  <v-autocomplete
                                    v-model="searchParams.gender"
                                    solo
                                    filled
                                    label="Gender"
                                    :items="['All', 'Male', 'Female']"
                                    @change="search"
                                  ></v-autocomplete>
                                </div>
                              </div>
                            </th>

                            <th class="md-table-head">
                              <div
                                class="md-table-head-container md-ripple md-disabled"
                              >
                                <div class="md-table-head-label">Mobile</div>
                                <div class="search_column">
                                  <v-autocomplete
                                    solo
                                    filled
                                    label="Mobile"
                                    v-model="searchParams.mobile"
                                    item-value="mobile"
                                    item-text="mobile"
                                    :items="phones"
                                    :loading="isLoading"
                                    :search-input.sync="phone"
                                    @change="getFilterData"
                                  ></v-autocomplete>
                                </div>
                              </div>
                            </th>
                            <th class="md-table-head">
                              <div
                                class="md-table-head-container md-ripple md-disabled"
                              >
                                <div class="md-table-head-label">Country</div>
                                <div class="search_column">
                                  <v-autocomplete
                                    solo
                                    filled
                                    label="Country"
                                    v-model="searchParams.nationality"
                                    item-value="id"
                                    item-text="name"
                                    :items="['All', ...countries]"
                                    @change="getFilterData"
                                  ></v-autocomplete>
                                </div>
                              </div>
                            </th>
                            <th class="md-table-head">
                              <div
                                class="md-table-head-container md-ripple md-disabled"
                              >
                                <div class="md-table-head-label">
                                  Reported By
                                </div>
                              </div>
                            </th>
                            <th class="md-table-head">
                              <div
                                class="md-table-head-container md-ripple md-disabled"
                              >
                                <div class="md-table-head-label">Reason</div>
                              </div>
                            </th>
                            <th class="md-table-head">
                              <div
                                class="md-table-head-container md-ripple md-disabled"
                              >
                                <div class="md-table-head-label">Action</div>
                              </div>
                            </th>
                          </tr>
                        </thead>

                        <tbody>
                          <tr
                            class="md-table-row"
                            v-for="(data, index) in searchDatas"
                            :key="data.id"
                          >
                            <td class="md-table-cell">
                              <div class="md-table-cell-container">
                                <v-btn
                                  @click="
                                    $router.push({
                                      name: 'ViewUser',
                                      params: { userId: data.id },
                                    })
                                  "
                                  small
                                  color="normal"
                                  >{{
                                    data.name != null ? data.name : "NA"
                                  }}</v-btn
                                >
                              </div>
                            </td>

                            <td class="md-table-cell">
                              <div class="md-table-cell-container">
                                {{ data.email }}
                              </div>
                            </td>
                            <td class="md-table-cell">
                              <div class="md-table-cell-container">
                                {{ data.profession ? data.profession : "NA" }}
                              </div>
                            </td>
                            <td class="md-table-cell">
                              <div class="md-table-cell-container">
                                {{
                                  data.company_name ? data.company_name : "NA"
                                }}
                              </div>
                            </td>

                            <td class="md-table-cell">
                              <div class="md-table-cell-container">
                                {{ data.gender || "--" }}
                              </div>
                            </td>

                            <td class="md-table-cell">
                              <div class="md-table-cell-container">
                                {{ data.mobile || "--" }}
                              </div>
                            </td>
                            <td class="md-table-cell">
                              <div class="md-table-cell-container">
                                {{ data.country_name || "--" }}
                              </div>
                            </td>
                            <td class="md-table-cell">
                              <div class="md-table-cell-container">
                                <v-btn
                                  @click="
                                    $router.push({
                                      name: 'ViewUser',
                                      params: { userId: data.reported_user_id },
                                    })
                                  "
                                  small
                                  color="normal"
                                  >{{
                                    data.reported_user != null
                                      ? data.reported_user
                                      : "NA"
                                  }}</v-btn
                                >
                              </div>
                            </td>
                            <td class="md-table-cell">
                              <div class="md-table-cell-container">
                                {{ data.reason || "--" }}
                              </div>
                            </td>
                            <td class="md-table-cell" style="min-width: 120px">
                              <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-btn
                                    v-if="data.status_id == 2"
                                    x-small
                                    depressed
                                    disabled
                                    v-bind="attrs"
                                    v-on="on"
                                    color="error"
                                    class="d-inline-block text-truncate"
                                    fab
                                  >
                                    <v-icon dark>{{
                                      "mdi-lock"
                                    }}</v-icon></v-btn
                                  >
                                  <v-btn
                                    v-else
                                    x-small
                                    :color="
                                      data.status_id == 1 ? 'success' : 'error'
                                    "
                                    class="d-inline-block text-truncate"
                                    dark
                                    v-bind="attrs"
                                    v-on="on"
                                    @click="changeUserStatus(data.id, index)"
                                    fab
                                  >
                                    <v-icon dark>{{
                                      data.status_id == 1
                                        ? "mdi-lock-open-variant"
                                        : "mdi-lock"
                                    }}</v-icon></v-btn
                                  >
                                </template>
                                <span>{{
                                  data.status_id == 1
                                    ? "Deactivate"
                                    : "Activate"
                                }}</span>
                              </v-tooltip>
                              &nbsp;
                              <v-tooltip top>
                                <template v-slot:activator="{ on, attrs }">
                                  <v-icon
                                    v-bind="attrs"
                                    v-on="on"
                                    color="primary"
                                    @click="forceLogout(data.id)"
                                    >mdi-logout-variant</v-icon
                                  >
                                </template>
                                <span>Force logout</span>
                              </v-tooltip>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <v-pagination
                    v-model="page"
                    :length="totalPages"
                  ></v-pagination>
                </div>
              </div>
            </div>
          </div>
        </v-row>
      </v-col>
    </v-row>
    <user-model
      v-bind="userModel"
      @close="userModel.userID = null"
      @updated="search()"
    />
    <v-dialog v-model="addAdminUserDialog" scrollable width="50%">
      <v-form ref="form" v-model="valid">
        <v-card>
          <v-card-title class="headline"
            >{{ userForm.id != null ? "Update" : "Add" }} Admin
            User</v-card-title
          >
          <v-card-text class="form_bg">
            <v-container>
              <v-row no-gutters justify="center">
                <v-col md="4">
                  <image-upload
                    :image_path="userForm.image_path"
                    default_image="default"
                    @upload="
                      (imagedata) => {
                        userForm.profile_image = imagedata;
                      }
                    "
                    :height="300"
                  ></image-upload>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                    v-model="userForm.name"
                    outlined
                    background-color="#fff"
                    label="Name*"
                    required
                    :rules="[(v) => !!v || 'Name is required']"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                    v-model="userForm.email"
                    outlined
                    background-color="#fff"
                    label="Email*"
                    required
                    :rules="[
                      (v) => !!v || 'E-mail is required',
                      (v) => /.+@.+\..+/.test(v) || 'E-mail must be valid',
                    ]"
                  ></v-text-field>
                </v-col>

                <v-col cols="12" sm="6" md="6">
                  <mobile-field
                    v-model="userForm.mobile"
                    label="Phone*"
                    outlined
                    background-color="#fff"
                    required
                  ></mobile-field>
                </v-col>
                <v-col cols="12" sm="6" md="6">
                  <v-text-field
                    v-model="userForm.username"
                    outlined
                    background-color="#fff"
                    label="Username*"
                    autocomplete="off"
                    :name="`username_${Math.random()}`"
                    required
                    :rules="[(v) => !!v || 'Username is required']"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field
                    :type="userForm.hidePassword1 ? 'text' : 'password'"
                    :append-icon="
                      userForm.hidePassword1 ? 'mdi-eye' : 'mdi-eye-off'
                    "
                    label="Password*"
                    outlined
                    background-color="#fff"
                    v-model="userForm.password"
                    @click:append="
                      userForm.hidePassword1 = !userForm.hidePassword1
                    "
                    required
                    autocomplete="new-password"
                    :name="`password_${Math.random()}`"
                    :rules="[(v) => !!v || 'Password is required']"
                  />
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    :type="userForm.hidePassword2 ? 'text' : 'password'"
                    :append-icon="
                      userForm.hidePassword2 ? 'mdi-eye' : 'mdi-eye-off'
                    "
                    label="Confirm password*"
                    outlined
                    background-color="#fff"
                    :autocomplete="
                      `user-password-confirm-${parseInt(userForm.name)}`
                    "
                    v-model="userForm.password_confirm"
                    @click:append="
                      userForm.hidePassword2 = !userForm.hidePassword2
                    "
                    validate-on-blur
                    required
                    :rules="[
                      (v) => !!v || 'Password is required',
                      (v) =>
                        v == this.userForm.password ||
                        'Password does not match',
                    ]"
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              class="ma-2 white--text green-color"
              @click="cancelAdminUserCreate"
              >Cancel</v-btn
            >

            <v-btn
              class="ma-2 white--text blue-color"
              @click="addOrEditAdminUser"
              >{{ userForm.id != null ? "Update" : "Save" }}</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </v-container>
</template>
<script>
import UserModel from "./UserModel";
export default {
  components: {
    UserModel,
  },
  data() {
    return {
      addAdminUserDialog: false,
      users: [],
      show2: false,
      valid: true,
      userForm: {},
      currentPage: 0,
      pageSize: 10,
      names: [],
      name: null,
      nationality: null,
      phones: [],
      phone: null,
      emails: [],
      email: null,
      isLoading: false,
      searchDatas: [],
      searchFlag: false,
      searchParams: {},
      AgeRange: ["All", "18-25", "26-30", "31-35"],
      Age: [],
      toAge: null,
      fromAge: null,
      page: 1,
      perPage: null,
      totalPages: 1,
      fieldData: {
        Name: "name",
        Mobile: "mobile",
        Email: "email",
        Age: "age",
        Gender: "gender",
        Nationality: "nationality",
      },
      userModel: { userID: null, type: "details" },
    };
  },
  mounted() {
    if (this.$store.getters.getCountries.status == false) {
      this.$store.dispatch("loadCountries");
    }
    // this.$store.dispatch("loadUsers");
    this.search();
  },
  computed: {
    countries() {
      return this.$store.getters.getCountries.data;
    },
  },
  watch: {
    page() {
      this.search();
    },
    name(val) {
      if (val == "" || val == null) return;
      if (this.isLoading) return;
      this.filterSearch("name", val);
    },
    phone(val) {
      if (val == "" || val == null) return;
      if (this.isLoading) return;
      this.filterSearch("mobile", val);
    },
    email(val) {
      if (val == "" || val == null) return;
      if (this.isLoading) return;
      this.filterSearch("email", val);
    },
    company_name(val) {
      if (val == "" || val == null) return;
      if (this.isLoading) return;
      this.filterSearch("company_name", val);
    },
    profession(val) {
      if (val == "" || val == null) return;
      if (this.isLoading) return;
      this.filterSearch("profession", val);
    },
    nationality(val) {
      if (val == "" || val == null) return;
      if (this.isLoading) return;
      this.filterSearch("nationality", val);
    },
  },
  methods: {
    filterSearch(type, val) {
      if (val == "All") return;
      this.isLoading = true;
      this.$http
        .get("users/filters?field=" + type + "&search=" + val)
        .then((response) => {
          if (response.status == 200 && response.data.status) {
            this.isLoading = false;
            if (type == "name") {
              this.names = response.data.data;
              this.names.unshift(val);
              this.names.unshift("All");
            } else if (type == "mobile") {
              this.phones = response.data.data;
              this.phones.unshift(val);
              this.phones.unshift("All");
            } else if (type == "email") {
              this.emails = response.data.data;
              this.emails.unshift(val);
              this.emails.unshift("All");
            } else if (type == "company_name") {
              this.company_names = response.data.data;
              this.company_names.unshift(val);
              this.company_names.unshift("All");
            } else if (type == "profession") {
              this.professions = response.data.data;
              this.professions.unshift(val);
              this.professions.unshift("All");
            } else if (type == "nationality") {
              this.countries = response.data.data;
              this.countries.unshift(val);
              this.countries.unshift("All");
            }
          }
        })

        .catch((error) => {
          this.errorChecker(error);
        });
    },
    getFilterData() {
      this.page = 1;
      this.search();
    },
    ageOkClick() {
      if (this.fromAge != null && this.toAge != null) {
        this.searchParams.from_age = this.fromAge;
        this.searchParams.to_age = this.toAge;
        let customAgeRange = this.fromAge + "-" + this.toAge;
        this.AgeRange.push(customAgeRange);
        this.searchParams.age = customAgeRange;
        this.toAge = null;
        this.fromAge = null;
        this.$refs.ageRef.blur();
        this.search();
      }
    },
    ageChange() {
      if (this.searchParams.age != "All") {
        let data = this.searchParams.age.split("-");
        this.searchParams.from_age = data[0];
        this.searchParams.to_age = data[1];
        this.search();
      } else {
        this.allAge();
      }
    },
    allAge() {
      delete this.searchParams.from_age;
      delete this.searchParams.to_age;
      delete this.searchParams.age;
      this.search();
    },
    showUserModel(userId) {
      this.userModel.userID = parseInt(userId);
      this.userModel.type = "details";
    },
    search() {
      let url = "";
      if (this.searchParams.name == "All") {
        this.searchParams.name = null;
      } else if (typeof this.searchParams.name != "undefined") {
        url += "&name=" + this.searchParams.name;
      }
      if (this.searchParams.email == "All") {
        delete this.searchParams.email;
      } else if (typeof this.searchParams.email != "undefined") {
        url += "&email=" + this.searchParams.email;
      }

      if (this.searchParams.mobile == "All") {
        delete this.searchParams.mobile;
      } else if (typeof this.searchParams.mobile != "undefined") {
        url += "&mobile=" + this.searchParams.mobile;
      }
      if (this.searchParams.gender == "All") {
        delete this.searchParams.gender;
      } else if (typeof this.searchParams.gender != "undefined") {
        url += "&gender=" + this.searchParams.gender;
      }
      if (this.searchParams.company_name == "All") {
        this.searchParams.company_name = null;
      } else if (typeof this.searchParams.company_name != "undefined") {
        url += "&company_name=" + this.searchParams.company_name;
      }
      if (this.searchParams.profession == "All") {
        this.searchParams.profession = null;
      } else if (typeof this.searchParams.profession != "undefined") {
        url += "&profession=" + this.searchParams.profession;
      }
      if (this.searchParams.nationality == "All") {
        delete this.searchParams.nationality;
      } else if (typeof this.searchParams.nationality != "undefined") {
        url += "&nationality=" + this.searchParams.nationality;
      }
      if (
        typeof this.searchParams.from_age != "undefined" &&
        typeof this.searchParams.to_age != "undefined"
      ) {
        url +=
          "&from_age=" +
          this.searchParams.from_age +
          "&to_age=" +
          this.searchParams.to_age;
      }
      this.showLoader("Loading Users");
      this.$http
        .get(
          "users/admin/reported-users?page=" +
            this.page +
            "&per_page=" +
            (this.perPage != null ? this.perPage : 10) +
            url
        )
        .then((response) => {
          this.hideLoader();
          if (response.status == 200 && response.data.status) {
            this.searchDatas = response.data.data;
            this.totalPages = response.data.total_pages;
          }
        })
        .catch((error) => {
          this.errorChecker(error);
        });
    },

    checkMobileExist() {
      if (this.loading) return;
      this.showLoader("Checking");
      this.loading = true;
      this.$http
        .get(`users?mobile=${this.userForm.mobile}`)
        .then((response) => {
          if (response.status == 200) {
            // this.isSearchLoading = false;
            this.hideLoader();
            this.loading = false;
            let data = response.data.data;
            if (data.length > 0) {
              this.userForm.mobile = null;
              this.showError("Customer exist with same mobile number");
              return false;
            } else {
              return true;
            }
          }
        })
        .catch((error) => {
          this.errorChecker(error);
        });
    },
    ok(id, index) {
      this.$http
        .put(`users/${id}/status`)
        .then((response) => {
          if (response.status == 200) {
            let status = response.data.data.status_id;
            this.users[index].status_id = status;
            this.showSuccess(
              `User ${status == 1 ? "activated" : "deactivated"} successfully`
            );
          }
        })
        .catch((error) => {
          this.errorChecker(error);
        });
    },
    changeUserStatus(id, index) {
      this.$http
        .put(`users/toggle-status/${id}`)
        .then((response) => {
          if (response.status == 200) {
            let status = response.data.data.status_id;
            this.searchDatas[index].status_id = status;
            this.showSuccess(
              `User ${status == 1 ? "activated" : "deactivated"} successfully`
            );
          }
        })
        .catch((error) => {
          this.errorChecker(error);
        });
    },
    forceLogout(id) {
      this.showLoader("Checking");
      let formData = new FormData();
      formData.set("user_id", id);
      this.$http({
        url: "users/admin/force-logout",
        method: "POST",
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data;",
        },
      })
        .then((response) => {
          if (response.status == 200) {
            this.hideLoader();
            // let status = response.data.data.status_id;
            this.showSuccess(`User account logout successfully`);
          }
        })
        .catch((error) => {
          this.hideLoader();
          this.errorChecker(error);
        });
    },
    cancelAdminUserCreate() {
      this.$refs.form.resetValidation();
      this.UserForm = {};
      this.addAdminUserDialog = false;
    },
    onResize() {
      if (this.$refs.card) this.height = this.$refs.card.$el.clientHeight - 100;
    },
    addOrEditAdminUser() {
      event.preventDefault();
      if (!this.$refs.form.validate()) {
        this.showError("Please complete all required fields");
        return;
      }
      let formData = new FormData();
      formData.set("name", this.userForm.name);
      if (this.userForm.password != null) {
        formData.set("password", this.userForm.password);
      }
      if (this.userForm.email != null) {
        formData.set("email", this.userForm.email);
      }
      if (this.userForm.profile_image) {
        formData.set("profile_image", this.userForm.profile_image);
      }
      formData.set("mobile", this.userForm.mobile);
      formData.set("username", this.userForm.username);
      this.$http({
        url:
          "users/register-admin" +
          (this.userForm.id ? `/${this.userForm.id}` : ""),
        method: "POST",
        data: formData,
        headers: {
          "Content-Type": "multipart/form-data; boundary=${form._boundary}",
        },
      })
        .then((response) => {
          if (response.status == 200) {
            this.addAdminUserDialog = false;
            this.showSuccess("Admin User Added Successfully.");
            this.search();
            //  this.$store.dispatch("loadUsers");
          }
        })
        .catch((error) => {
          this.errorChecker(error);
        });
    },
    addUser() {
      this.userForm = {};
      this.subModules = [];
      this.addAdminUserDialog = true;
      setTimeout(() => {
        this.onResize();
      }, 10);
    },
  },
};
</script>
<style scoped>

.validation-message {
  color: red;
  font-size: 12px;
}
.md-card {
  margin: 0 0 25px 0;
}
.hoverImage {
  background-color: rgba(54, 54, 54, 0.342);
}
.salesBtn {
  padding: 5px;
  font-size: 14px;
  font-weight: bold;
  color: #066a8c;
}
.btn_bg {
  background-color: #fff;
  border-bottom: 3px solid #066a8c;
  border-radius: 10px;
  box-shadow: 0 3px 3px -2px black;
}
</style>
